export default __webpack_public_path__ + "static/media/Spinner.58bcfbd5.gif";